module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/movie-thumbnail-60e6a3c9f5f8361a31457e38030e66a8.png";